import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  variant?: "primary" | "secondary" | "light" | "dark";
}

export default function Logo({ className, variant = "primary" }: LogoProps) {
  const getColor = () => {
    switch (variant) {
      case "light":
        return "text-white";
      case "dark": 
        return "text-black-1";
      case "secondary":
        return "text-black-1";
      default:
        return "text-black-1";
    }
  };

  return (
     <div className={cn("relative w-full max-w-4xl mx-auto", className)}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("transition-colors", getColor(), className)}
      >
        <defs>
          <linearGradient id="primaryGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="hsl(var(--primary))" />
            <stop offset="100%" stopColor="hsl(var(--primary-glow))" />
          </linearGradient>
          <linearGradient id="accentGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="hsl(var(--primary) / 0.2)" />
            <stop offset="50%" stopColor="hsl(var(--primary) / 0.5)" />
            <stop offset="100%" stopColor="hsl(var(--primary) / 0.2)" />
          </linearGradient>
        </defs>

        <circle
          cx="16"
          cy="16"
          r="14"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
        
        />
        <circle
          cx="16"
          cy="16"
          r="10"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          
        />      
        <circle
          cx="16"
          cy="16"
          r="6"
          stroke="currentColor"
          strokeWidth="2"
          fill="hsl(var(--primary))"
        className={true ? "animate-pulse" : ""}
        />            
      </svg>
     </div>
  );
}